import md5 from '../assets/js/md5'
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "../assets/js/until"
// 公共工具1(相关业务,内容,场景应用)
export const contTools = {
  data() {
    return {
      isPC: "",
      isDiscount: this.$cookies.get("gid"),
      urlObj: this.$route.query, // 地址栏参数
      screenWidth: document.body.clientWidth,
      // urlObj: comTools.getRequest(),
      uA: navigator.userAgent,
      andUa: navigator.userAgent.indexOf("BHWebView") > -1,
      iOSUa: navigator.userAgent.indexOf("iOSWebUA") > -1
    }
  },
  watch: {
    $route(to, from) {
      this.urlObj = this.$route.query;
    }
  },
  created() {
    if (this.screenWidth >= 500) {
      this.initView();
    }
  },
  mounted() {
    window.onresize = comTools.setDebounce(this.initView);
  },
  methods: {
    // 界面适配(区分pc端||移动端,显示滚动条)
    initView() {
      let ua = navigator.userAgent.toLowerCase();
      let mobile = /mobile/gi.test(ua);
      let html = document.querySelector('html');
      let body = document.querySelector('body');
      this.isPC = !mobile;
      if (this.isPC) {
        html.style.fontSize = '32px'
        body.setAttribute('id', 'pcBody')
        // console.log("当前PC");
        this.isPcDown = true;
      } else {
        console.log("当前不是PC");
        body.removeAttribute('id', 'pcBody')
        this.isPcDown = false;
      }
    },

    /**
     * 
     * @param {跳转路径} path 
     * @param {query对象} query 
     */
    gameDateil(path, query) {
      this.$router.push({
        path: `/${path}`,
        query: query
      });
    },

    /**
     * 获取时间戳
     */
    getTm() {
      var tmp = Date.parse(new Date())
      if (tmp) {
        tmp = tmp.toString().substr(0, 10);;
      } else {
        tmp = Math.round(new Date().getTime() / 1000)
      }
      return tmp;
    },

    /**
     * 请求公共参数
     * 101-ios 100-h5 102-and
     * pmid区分渠道
     */
    wapConfig() {
      let wapConfig = {
        app_pid: this.$store.state.wapConfig.pid || this.$cookies.get('pid') || 102,
        app_gid: this.$store.state.wapConfig.gid || this.$cookies.get('gid') || 1002,
        app_p_mid: this.$store.state.wapConfig.pmid || this.$cookies.get('pmid') || 1,
        app_mid: this.$store.state.wapConfig.mid || this.$cookies.get('mid') || 10000,
        tm: this.getTm(),
        client_type: this.$store.state.wapConfig.client_type || this.$cookies.get('client_type') || 'h5'
        // app_pid: this.$store.state.wapConfig.pid,
        // app_gid: this.$store.state.wapConfig.gid,
        // app_p_mid: this.$store.state.wapConfig.pmid,
        // app_mid: this.$store.state.wapConfig.mid,+

        // tm: this.getTm(),
        // client_type: this.$store.state.wapConfig.client_type,
      }

      return wapConfig;
    },

    /**
     * @param {字符串} value 
     */
    gameType(value) {
      let arr = [];
      if (!value) return "";
      if (value.indexOf(",") > -1) {
        arr = value.split(",");
        return arr;
      } else {
        arr.push(value);
        return arr;
      }
    },

  },
}
// 公共工具2(多场景应用)
export const lyTool = {
  data() {
    return {
      mobile: this.$store.state.mobile || $cookies.get("mobile"),
      isMask: false, // 提示跳转浏览器蒙版
      urlData: this.$route.query, // 地址栏参数
    }
  },
  created() {
    // console.log('iOS', this.urlData);
  },
  methods: {
    /**
     * 获取md5
     * @param {*} target
     */
    getMd5(target) {
      return md5(target);
    },
    /**
     * 加密处理
     * @param {*} queryObj 
     * @param {*} noMd5 
     * @param {*} elseQuery 
     */
    querySort(queryObj, noMd5, elseQuery) {
      const keyArr = Object.keys(queryObj);
      let str = '';
      // 兼容低端安卓机
      if (!Array.prototype.findIndex) {
        Array.prototype.findIndex = function (predicate) {
          if (this == null) {
            throw new TypeError('Array.prototype.findIndex called on null or undefined');
          }
          if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
          }
          var list = Object(this);
          var length = list.length >>> 0;
          var thisArg = arguments[1];
          var value;

          for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
              return i;
            }
          }
          return -1;
        };
      }
      keyArr.indexOf('sign') > -1 ? keyArr.splice(keyArr.findIndex(item => item === 'sign'), 1) : ''
      keyArr.sort();
      for (let i = 0; i < keyArr.length; i += 1) {
        if (queryObj[keyArr[i]] !== 0 && queryObj[keyArr[i]]) {
          str = `${str}&${keyArr[i]}=${queryObj[keyArr[i]]}`;
        }
      }
      if (noMd5) {
        return `${str.substr(1)}`;
      } else {
        let arr = ['173', '183']
        if (elseQuery && arr.indexOf(elseQuery.pid.toString()) > -1) {
          // console.log(`${str.substr(1)}${elseQuery.appKey}`,'======sign')
          return this.getMd5(`${str.substr(1)}${elseQuery.appKey}`);
        } else {
          console.log('sign', str.substr(1))
          return this.getMd5(`${str.substr(1)}&`);
        }
      }
    },

    /**
     * 创建client_id
     */
    getIdfa() {
      const myDate = new Date();
      let idfa = 'h5';
      const num = parseInt(Math.random() * (9999999999 - 1), 10);
      idfa += myDate.getFullYear();
      idfa += '-' + (myDate.getMonth() + 1);
      idfa += '-' + myDate.getDate();
      idfa += '-' + myDate.getHours();
      idfa += '-' + myDate.getMinutes();
      idfa += '-' + myDate.getSeconds();
      idfa += '-' + num;
      localStorage.setItem('glIdfa', idfa);
      return idfa;
    },

    /**
     * 对应系统下载
     */
    lyDownGame(sysType, btnListData) {
      let u = navigator.userAgent;
      let urlData = this.$route.query;
      let mid = urlData.glMid;
      this.system = sysType;
      console.log('btnListData', btnListData);
      if (btnListData.url) {
        // 是否有下载地址
        if (/(iPhone|iPad|iPod|iOS|Android)/i.test(u)) {
          if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) && this.system == 1) {
            this.comData.pid = btnListData.pid || this.urlData.glPid;
            this.comData.gid = btnListData.gid || this.urlData.glGid;
            // iOS终端
            if (this.isLogin) {
              console.log(this.mobile, "--this.mobile");
              let _isMobile = this.mobile != "undefined" &&
                this.mobile != undefined;
              if (_isMobile) {
                window.location = this.btn_list.ios.url
              } else {
                // 提示绑定手机
                this.contShow = true;
                this.codeShow = true;
                this.onShow('bind');
              }
            } else {
              this.contShow = true;
              this.codeShow = true;
              this.onShow("phoneLogin");
            }
            // console.log('iOS终端');
          } else if (/(Android)/i.test(u) && this.system == 2) { // Android终端
            this.comData.pid = btnListData.pid || this.urlData.glPid;
            this.comData.gid = btnListData.gid || this.urlData.glGid;
            if (mid) {
              if (this.isLogin) {
                window.location = this.btn_list.az.url
              } else {
                this.contShow = true;
                this.codeShow = true;
                this.onShow("phoneLogin");
              }
            } else {
              window.location = this.btn_list.az.url
            }
          } else if (this.system == 3) {
            this.comData.pid = btnListData.pid || this.urlData.glPid;
            this.comData.gid = btnListData.gid || this.urlData.glGid;
            if (mid) {
              if (this.isLogin) {
                window.location = this.btn_list.h5.url
              } else {
                this.contShow = true;
                this.codeShow = true;
                this.onShow("phoneLogin");
              }
            } else {
              window.location = this.btn_list.h5.url
            }

          } else {
            if (this.system == 1) {
              this.$toast('当前手机不支持!')
            } else {
              this.$toast('当前手机不支持!')
            }
          }
        } else { // pc端
          if (this.system == 1) { // ios
            this.comData.pid = btnListData.pid || this.urlData.glPid;
            this.comData.gid = btnListData.gid || this.urlData.glGid;
            this.$toast('请使用手机Safari打开');
          } else if (this.system == 2) { // 安卓
            this.comData.pid = btnListData.pid || this.urlData.glPid;
            this.comData.gid = btnListData.gid || this.urlData.glGid;
            if (mid) {
              if (this.isLogin) {
                window.location = this.btn_list.az.url
              } else {
                this.contShow = true;
                this.codeShow = true;
                this.onShow("phoneLogin");
              }
            } else {
              window.location = this.btn_list.az.url
            }
          } else {
            this.comData.pid = btnListData.pid || this.urlData.glPid;
            this.comData.gid = btnListData.gid || this.urlData.glGid;
            if (mid) {
              if (this.isLogin) {
                window.location = this.btn_list.h5.url
              } else {
                this.contShow = true;
                this.codeShow = true;
                this.onShow("phoneLogin");
              }
            } else {
              window.location = this.btn_list.h5.url
            }
          }
        }
      } else {
        this.$toast('敬请期待!');
      }


    },

    /**
     * 默认识别系统下载
     */
    barDownGame() {
      let urlData = this.$route.query
      let mid = urlData.mid ? '' : '10000'
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        if (this.isLogin) {
          window.location = 'https://store.iphoneapple.cn/ioshelper/details?appid=36df9190-59f5-11ea-b882-affb0dddfe94'
        } else {
          this.contShow = true;
        }
        console.log('iOS终端');

      } else if (/(Android)/i.test(navigator.userAgent)) {
        //Android终端
        console.log('Android终端');
        let aUrl =
          window.location = `https://app-1300876621.cos.ap-guangzhou.myqcloud.com/Apk/cps/${urlData.glGid}_${urlData.glPid}_${urlData.glPMid}_${mid}.apk`
      }
    },

    /**
     * 是否是微信
     */
    isWeixin() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWeixinWeb = true;
        return true;
      }
      return false;
    },
    /**
     * 分系统玩(ios只能h5,安卓下载微端)
     */
    isAndroid() {
      let u = navigator.userAgent;
      if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
        // if (window.ShowFitness !== undefined) return true;
        return true;
      }
      return false;
    },
    /**
     *   判断设备为 ios
     */
    isIos() {
      let u = navigator.userAgent;
      if (/(iPhone|iPad|iPod|iOS)/i.test(u)) {
        return true;
      }
      return false;
    },
    /**
     * 验证手机号
     * phone 手机号
     */
    checkPhone() {
      if (!/^1(3|4|5|7|8)\d{9}$/.test(this.phone)) {
        this.$toast({
          message: "请输入正确的手机号码",
          duration: 2000
        });
        setTimeout(() => {
          this.phone = "";
        }, 2000);
      }
    },

    /**
     * 官网获取短信验证码
     */
    getCode(type) {
      if (this.inputCheck(this.phone, "phone")) {
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.phone,
          type: type
        });
        data.sign = comTools.querySort(data);
        wapApiFun.sendCode(data).then(res => {
          if (res.code === 200) {
            // this.code = res.data.vcode;
            if (!this.timer) {
              // 验证码倒计时
              this.count = 60;
              this.codeShow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= 60) {
                  this.count--;
                } else {
                  this.codeShow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                  this.code = "";
                }
              }, 1000);
            }
            this.$toast({
              message: res.msg,
              duration: 2000
            });
          } else {
            this.$toast({
              message: res.msg,
              duration: 2000
            });
          }
        });
      }
    },


    /**
     * 检验输入框
     * @param {*} val 数值
     * @param {*} type 检验类型
     * @param {*} tipsObj 提示dom
     */
    inputCheck(val, type) {
      if (type === 'acount') {
        if (val === '') {
          this.$toast({
            message: '账号不能为空',
            duration: 2000
          });
          return false;
        }
      }
      if (type === 'phone') {
        if (!this.vPhone(val)) {
          this.$toast({
            message: '手机格式不正确',
            duration: 2000
          });
          return false;
        }
      }
      if (type === 'yzm') {
        if (val === '') {
          this.$toast({
            message: '验证码不能为空',
            duration: 2000
          });
          return false;
        }
      }
      if (type === 'pwd') {
        if (val === '') {
          this.$toast({
            message: '密码不能为空',
            duration: 2000
          });
          return false;
        }
        if (!this.vPass(val)) {
          this.$toast({
            message: '密码格式不正确',
            duration: 2000
          });
          return false;
        }
      }
      if (type === 'checkbox') {
        if (!val) {
          this.$toast({
            message: '请勾选协议',
            duration: 2000
          });
          return false;
        }
      }
      if (type === 'name') {
        if (val === '') {
          this.$toast({
            message: '姓名不能为空',
            duration: 2000
          });
          return false;
        }
      }
      if (type === 'id') {
        if (val === '') {
          this.$toast({
            message: '身份证不能为空',
            duration: 2000
          });
          return false;
        }
        if (val.length !== 18) {
          this.$toast({
            message: '身份证格式不正确',
            duration: 2000
          });
          return false;
        }
      }
      return true;
    },

    /**
     *  检验手机号码
     */
    vPhone(str) {
      // const pattern2 = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
      // pattern2.test(str);
      str = str + ''
      return str.length === 11 ? true : false
    },

    /**
     * 检验密码
     * @param {*} str
     */
    vPass(str) {
      const pattern1 = /^\w{6,20}$/; // 字母数字下划线6-20,/^\w{6,20}$/
      return pattern1.test(str);
    },

    /**
     * 检测数字位数
     * @param {*} str
     */
    vSixNum(str) {
      const pattern3 = /^\d{6}$/;
      return pattern3.test(str);
    },

    /**
     * 给目标标签添加底部高度
     * @param {目标标签} target 
     * @param {底部高度} height 
     */
    addPaddingBottom(target, height) {
      if (this.isIos()) {
        target.style.paddingBottom = height;
      }

    },

    /**
     * @param {后台推的游戏端} system 
     * @param {下载地址后,ios落下载页} item 
     * @param {子游戏id} gid 
     */
    downGame(item, system, gid) {
      // console.log('111133', item, system, gid);
      if (item) {
        switch (true) {
          case system == 100: // h5
            if (this.$cookies.get("userToken")) {
              this.download(gid);
            } else {
              this.$router.replace({
                path: '/login'
              })
            }
            // window.location.href = item
            // window.open(item, "_blank");

            break;
            // case system == 101:
            //   window.open(item, "_blank");
            //   this.bindIos(gid);
            //   this.download(gid);
            //   break;
          case system == 102: // 安卓
            // window.open(item);
            window.location.href = item
            this.download(gid);
            break;
        }
      } else if (system == 101) { // ios
        if (this.$cookies.get("userToken")) {
          this.bindIos(gid);
          this.download(gid);
        } else {
          this.$router.replace({
            path: '/login'
          })
        }
      } else {
        this.$toast('敬请期待')
      }
    },

    /**
     * 下载量
     */
    download(gId) {
      let data = comTools.assignObj(this.wapConfig(), {
        gid: gId,
        mobile: this.$store.state.mobile,
      });
      data.sign = comTools.querySort(data);
      wapApiFun.download(data).then(res => {
        console.log("h5开玩", res);
        if (res.code == 200) {
          if (res.data.url != "") {
            window.open(res.data.url);
          } else {
            this.$toast('敬请期待');
          }

        }
      });
    },
    /**
     * ios绑定归属
     */
    bindIos(gId) {
      let data = comTools.assignObj(this.wapConfig(), {
        mobile: this.$cookies.get("mobile"),
        gid: gId,
        user_token: this.$cookies.get("userToken"),
      });
      data.sign = comTools.querySort(data);
      wapApiFun.bindIos(data).then(res => {
        if (res.code == 200) {
          if (res.data.ios_url) {
            window.location.href = res.data.ios_url
          } else {
            this.$toast('敬请期待');
          }

        }
      });
    }
  }
}